import { useTranslation } from "react-i18next";

export const DutyEmployees = ({ employees, selected, onToggle }) => {
  const { t } = useTranslation();

  return (
    <div data-testid="duty-employees">
      <p className="label-xs mb-2">{t("duty.employees")}</p>
      <div className="grid max-h-56 gap-2 overflow-y-auto rounded-2xl border border-border/60 p-3 shadow-neu-in sm:grid-cols-2">
        {employees.length === 0 ? (
          <p className="text-xs text-muted-foreground">{t("app.none")}</p>
        ) : null}
        {employees.map((e) => (
          <label
            key={e.id}
            data-testid={`duty-employee-${e.id}`}
            className="flex cursor-pointer items-center gap-2 rounded-xl px-2 py-1.5 text-xs font-semibold transition-colors hover:text-primary"
          >
            <input
              type="checkbox"
              className="h-4 w-4 accent-[hsl(var(--primary))]"
              checked={selected.includes(e.id)}
              onChange={() => onToggle(e.id)}
            />
            <span className="truncate">{e.full_name || e.email}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
